import { MdOutlineCloudUpload } from 'react-icons/md';
import { BsCloudCheck, BsXCircleFill } from 'react-icons/bs';
import DropZonefile from 'views/admin/main/ecommerce/settingsProduct/components/DropZonefile';
import { useState, useEffect } from 'react';

const UploadSheets = ({
  submissiontext,
  setSubmissiontext,
  handleFileChange,
  fileUploaded,
  setFileUploaded,
}) => {
  const [uploadedFileName, setUploadedFileName] = useState('');
  const handleFileUploaded = (file) => {
    setFileUploaded(true);
    setUploadedFileName(file[0].name);
  };

  const handleRemoveFile = () => {
    setFileUploaded(false);
    setUploadedFileName('');
  };
  const handleInputChange = (e) => {
    setSubmissiontext(e.target.value);
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="mb-6 pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Upload Test Answer
      </h4>
      <div className="flex w-full items-center justify-center rounded-[20px]">
        <textarea
          value={submissiontext}
          onChange={handleInputChange}
          className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
          placeholder="Enter answer / links."
          rows="3"
        />
      </div>
    </div>
  );
};
export default UploadSheets;
